import { createThunks, Params } from 'tsx/libs/reduxUtils';
import { get } from 'tsx/libs/genericAction';
import { apiAppointmentActivities } from 'tsx/constants/api';

export const typePrefix = 'appointments-activities';

const config = [
  { actionType: 'getAll', apiPath: apiAppointmentActivities, method: get, actionParams: { limit: 0 } },
  { actionType: 'getOne', apiPath: (params: Params) => `${apiAppointmentActivities}/${params.id}`, method: get },
];

export const { getAll, getOne } = createThunks(typePrefix, config);
